var map = {
	"./archived.svg": "20b5",
	"./bannerGraphic.svg": "1a9c",
	"./complete.svg": "9cb3",
	"./notRequired.svg": "0aa8",
	"./pending.svg": "e25a",
	"./stack-icon.svg": "040a",
	"./vic-gov-logo.svg": "374a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a244";